import { createSelector } from 'reselect'
// import { List } from 'immutable'

const reportSelector = state => state.get('report')

export const getIsFetching = createSelector(
  reportSelector,
  reportImmutable => {
    const report = reportImmutable.toJS()
    return report.reportYearOfService.isFetching
    || report.reportHeadcount.isFetching
    || report.reportLeaveHistory.isFetching
    || report.reportActiveUsers.isFetching
    || report.reportLeaveGenerationGet.isFetching
    || report.reportCompensateGet.isFetching
    || report.reportCompensateCancel.isFetching
    || report.reportSubcontractGet.isFetching
    || report.reportCompensateExport.isFetching
    || report.reportAuditLogsExport.isFetching
    || report.reportSubcontractExport.isFetching
    || report.reportHeadcountExport.isFetching
    || report.reportYearOfServiceExport.isFetching
    || report.reportLeaveHistoryExport.isFetching
    || report.reportActiveUsersExport.isFetching
  }
)
export const getHeadcountData = createSelector(
  reportSelector,
  reportImmutable => {
    const report = reportImmutable.toJS()
    return report.reportHeadcount
  }
)
export const exportHeadcountData = createSelector(
  reportSelector,
  reportImmutable => {
    const report = reportImmutable.toJS()
    return report.reportHeadcountExport.url
  }
)
export const getYearOfServiceData = createSelector(
  reportSelector,
  reportImmutable => {
    const report = reportImmutable.toJS()
    return report.reportYearOfService.yearOfService
  }
)
export const exportYearOfServiceData = createSelector(
  reportSelector,
  reportImmutable => {
    const report = reportImmutable.toJS()
    return report.reportYearOfServiceExport.url
  }
)
export const getLeaveHistoryData = createSelector(
  reportSelector,
  reportImmutable => {
    const report = reportImmutable.toJS()
    return report.reportLeaveHistory
  }
)
export const exportLeaveHistoryData = createSelector(
  reportSelector,
  reportImmutable => {
    const report = reportImmutable.toJS()
    return report.reportLeaveHistoryExport
  }
)
export const getActiveUsersData = createSelector(
  reportSelector,
  reportImmutable => {
    const report = reportImmutable.toJS()
    return report.reportActiveUsers
  }
)
export const getCompensateReportData = createSelector(
  reportSelector,
  reportImmutable => {
    const report = reportImmutable.toJS()
    return report.reportCompensateGet
  }
)
export const cancelCompensateReportData = createSelector(
  reportSelector,
  reportImmutable => {
    const report = reportImmutable.toJS()
    return report.reportCompensateCancel
  }
)
export const getSubcontractReportData = createSelector(
  reportSelector,
  reportImmutable => {
    const report = reportImmutable.toJS()
    return report.reportSubcontractGet
  }
)
export const getLeaveGenerationReportData = createSelector(
  reportSelector,
  reportImmutable => {
    const report = reportImmutable.toJS()
    return report.reportLeaveGenerationGet
  }
)
export const exportActiveUsersData = createSelector(
  reportSelector,
  reportImmutable => {
    const report = reportImmutable.toJS()
    return report.reportActiveUsersExport.url
  }
)
export const exportAuditLogsData = createSelector(
  reportSelector,
  reportImmutable => {
    const report = reportImmutable.toJS()
    return report.reportAuditLogsExport.url
  }
)
export const exportSubcontractData = createSelector(
  reportSelector,
  reportImmutable => {
    const report = reportImmutable.toJS()
    return report.reportSubcontractExport.url
  }
)
export const exportCompensateData = createSelector(
  reportSelector,
  reportImmutable => {
    const report = reportImmutable.toJS()
    return report.reportCompensateExport.url
  }
)
export const redirectReport = createSelector(
  reportSelector,
  reportImmutable => {
    const report = reportImmutable.toJS()
    return ({
      redirect: (report.reportYearOfService.redirect
      || report.reportHeadcount.redirect
      || report.reportLeaveHistory.redirect
      || report.reportActiveUsers.redirect
      || report.reportLeaveGenerationGet.redirect
      || report.reportCompensateGet.redirect
      || report.reportCompensateCancel.redirect
      || report.reportSubcontractGet.redirect
      || report.reportCompensateExport.redirect
      || report.reportAuditLogsExport.redirect
      || report.reportSubcontractExport.redirect
      || report.reportHeadcountExport.redirect
      || report.reportYearOfServiceExport.redirect
      || report.reportLeaveHistoryExport.redirect
      || report.reportActiveUsersExport.redirect),
      isAuthenticated: (report.reportYearOfService.isAuthenticated
      || report.reportHeadcount.isAuthenticated
      || report.reportLeaveHistory.isAuthenticated
      || report.reportActiveUsers.isAuthenticated
      || report.reportLeaveGenerationGet.isAuthenticated
      || report.reportCompensateGet.isAuthenticated
      || report.reportCompensateCancel.isAuthenticated
      || report.reportSubcontractGet.isAuthenticated
      || report.reportCompensateExport.isAuthenticated
      || report.reportAuditLogsExport.isAuthenticated
      || report.reportSubcontractExport.isAuthenticated
      || report.reportHeadcountExport.isAuthenticated
      || report.reportYearOfServiceExport.isAuthenticated
      || report.reportLeaveHistoryExport.isAuthenticated
      || report.reportActiveUsersExport.isAuthenticated),
    })
  }
)



// WEBPACK FOOTER //
// ./src/selectors/report/report-selector.js